function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Button } from '../../../index.js';
import PropTypes from 'prop-types';

var NavLinkButton = function NavLinkButton(_ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, ['children']);

    return React.createElement(
        'div',
        { className: 'top-navigation-nav-link d-inline' },
        React.createElement(
            Button,
            rest,
            children
        )
    );
};

NavLinkButton.defaultProps = {
    variant: "default"
};
NavLinkButton.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * ALl the buttons properties are supported
     * Button children
     * Button text or children components
     */
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired

} : {};
export default NavLinkButton;